// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hover-popup-width: 220px;
  --detail-popup-width: 405px;
  --detail-popup-height: 506px;
  --detail-content-height: 450px;
  --popup-offset: 20px;
  --popup-spacing: 5px;
  --hover-popup-max-height: 248px;
  --color-success: #09AF91;
  --color-error: #FB4B4B;
  --color-error-secondary: #FF4C4C;
  --color-warning: #FFD700;
  --color-primary-blue: #386DFF;
  --bg-primary: #1C2633;
  --bg-secondary: #121B26;
  --bg-card: #0D1117;
  --bg-divider: #2A3A4F;
  --text-primary: #FDFDFD;
  --text-secondary: #708299;
  --text-tertiary: #A9BBC7;
  --text-code: #8998AB;
  --border-primary: #4B5F7A;
  --border-disabled: #6B7280;
  --border-future: #9CA3AF;
  --status-green: #55FC7F;
  --status-green-border: #84FFA3;
  --status-red-bg: #FFB3B3;
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 10px;
  --spacing-lg: 12px;
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --radius-xl: 12px;
  --radius-2xl: 32px;
  --flight-card-width: 337px;
  --flight-card-circle-size: 13px;
  --connection-indicator-width: 235px;
  --connection-indicator-height: 28px;
}
.hoverContainer {
  position: relative;
  width: 215px;
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}
.hoverContainer.withoutIssue {
  border: 3px solid var(--color-success);
}
.hoverContainer.withIssue {
  border: 3px solid var(--color-error);
}
.hoverContainer .hoverHeader {
  padding: var(--spacing-sm);
  text-align: center;
}
.hoverContainer .hoverHeader.withoutIssue {
  background: var(--color-success);
}
.hoverContainer .hoverHeader.withIssue {
  background: var(--color-error);
}
.hoverContainer .hoverHeader .headerText {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-primary);
  margin: 0 auto;
  width: fit-content;
}
.hoverContainer .hoverHeader .headerText .textView {
  padding-left: 3px;
}
.hoverContainer .hoverContent {
  flex: 1;
  padding: var(--spacing-sm) var(--spacing-lg);
  color: var(--text-primary);
  padding-right: var(--spacing-xs);
  margin-right: 3px;
  overflow-x: hidden;
}
.hoverContainer .hoverContent .contentText {
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
}
.hoverContainer .hoverContent .contentText .hoverArrow {
  padding-left: 10px;
  padding-right: 10px;
}
.hoverContainer .hoverContent .passenger-parent {
  max-height: 150px;
  overflow-y: auto;
  overflow-x: auto;
  padding-right: 4px;
  margin-top: 6px;
}
.hoverContainer .hoverContent .passenger-parent .multiplePassenger {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 8px;
  background: #0D1117;
  border: 1px solid #1C2633;
  border-radius: 8px;
  margin-top: 6px;
}
.popup-base {
  position: fixed;
  z-index: 9999;
  pointer-events: auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}
.passengerBox {
  padding-top: 5px;
  padding-bottom: 5px;
}
.passengerBox .passengerContainer {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  white-space: nowrap;
}
.passengerBox .passengerContainer:first-child {
  padding-bottom: 2px;
}
.passengerBox .passengerContainer .passengerLabel {
  color: #A9BBC7;
  flex-shrink: 0;
}
.passengerBox .passengerContainer .passengerValue {
  color: #FDFDFD;
  padding-left: 10px;
  white-space: nowrap;
}
.passenger-card {
  min-width: 190px;
}
.locationContainer {
  position: relative;
  width: 215px;
  background: #1C2633;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  border: 3px solid #2A3A4F;
  overflow-x: hidden;
}
.locationContainer.passengerClick {
  border: 3px solid #09AF91;
}
.locationContainer .locationHeader {
  padding: 8px;
  text-align: center;
  background: #2A3A4F;
}
.locationContainer .locationHeader.passengerClick {
  background: #09AF91;
}
.locationContainer .locationHeader .headerText {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
  margin: 0 auto;
  width: fit-content;
}
.locationContainer .locationHeader .headerText .textView {
  padding-left: 3px;
}
.locationContainer .locationContent {
  flex: 1;
  margin: 8px 12px;
  color: #FDFDFD;
  padding-right: 4px;
  margin-right: 3px;
  overflow-x: hidden;
}
.locationContainer .locationContent .contentText {
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  text-align: center;
}
.locationContainer .locationContent .passenger-parent {
  max-height: 150px;
  overflow-y: auto;
  overflow-x: auto;
  padding-right: 4px;
  margin-top: 6px;
}
.locationContainer .locationContent .multiplePassenger {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 8px;
  background: #0D1117;
  border: 1px solid #1C2633;
  border-radius: 8px;
  margin-top: 6px;
}
.detailContainer {
  position: relative;
  background: #1C2633;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  height: 506px;
  max-height: 506px;
  overflow-y: auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  width: 405px;
}
.detailContainer.multiplePassenger {
  left: 5px;
}
.detailContainer.withoutIssue {
  border: 3px solid #09AF91;
}
.detailContainer.withIssue {
  border: 3px solid #FB4B4B;
}
.detailContainer .detailHeader {
  padding: 6px;
  text-align: center;
}
.detailContainer .detailHeader.withoutIssue {
  background: #09AF91;
}
.detailContainer .detailHeader.withIssue {
  background: #FB4B4B;
}
.detailContainer .detailHeader .headerText {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
  margin: 0 auto;
  width: fit-content;
}
.detailContainer .detailHeader .headerText .textView {
  padding-left: 3px;
}
.detailContainer .detailContent {
  max-height: 450px;
  height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: 6px;
  margin-top: 6px;
}
.detailContainer .detailContent .content1 {
  padding: 10px;
  padding-top: 0px;
}
.detailContainer .detailContent .content1 .headerDetails {
  display: flex;
}
.detailContainer .detailContent .content1 .headerDetails .tripDetails {
  width: 25%;
  border-right: 1.5px solid #2A3A4F;
  padding: 5px 0px;
}
.detailContainer .detailContent .content1 .headerDetails .tripDetails .text {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #708299;
}
.detailContainer .detailContent .content1 .headerDetails .tripDetails .tripID {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-decoration-line: underline;
  color: #386DFF;
}
.detailContainer .detailContent .content1 .headerDetails .passengerDeatils {
  width: 75%;
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.detailContainer .detailContent .content1 .description {
  padding: 10px 0px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
}
.detailContainer .detailContent .content1 .dashedLine {
  height: 1.5px;
  background: repeating-linear-gradient(to right, #2A3A4F, #2A3A4F 10px, transparent 4px, transparent 20px);
}
.detailContainer .detailContent .content1 .locationBox {
  display: flex;
}
.detailContainer .detailContent .content1 .locationBox .location {
  border-bottom: 1.5px solid #2A3A4F;
  padding: 16px 0px;
  width: 45%;
  display: flex;
}
.detailContainer .detailContent .content1 .locationBox .location .locationDetail {
  width: 85%;
}
.detailContainer .detailContent .content1 .locationBox .location .locationDetail .airportCode {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #FDFDFD;
}
.detailContainer .detailContent .content1 .locationBox .location .locationDetail .cityName {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #708299;
}
.detailContainer .detailContent .content1 .locationBox .location .lineHeader {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content1 .locationBox .location .lineHeader .line {
  border: 1px solid #2A3A4F;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content1 .locationBox .arrow {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content1 .timeContainer {
  display: flex;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox {
  width: 45%;
  display: flex;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails {
  padding-top: 10px;
  width: 85%;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails:first-child {
  border-right: 1.5px solid #2A3A4F;
  margin-right: 8px;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleText {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: #8998AB;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleTime {
  display: flex;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleTime .time {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #FDFDFD;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleTime .timePeriod {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #708299;
  padding-left: 6px;
}
.detailContainer .detailContent .content1 .timeContainer .arrow {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content2 {
  background: #121B26;
  border-radius: 32px 32px 0px 0px;
  padding: 10px;
  margin-top: 10px;
  margin-right: 6px;
}
.detailContainer .detailContent .content2 .flightContainer:last-child .dotIcon::after {
  display: none;
}
.detailContainer .detailContent .content2 .flightContainer.selected .flightContent .dotParent .dotIcon {
  background: #FFFFFF;
  border: 2px solid #386DFF;
}
.detailContainer .detailContent .content2 .flightContainer.selected .flightContent .dotParent .dotIcon::after {
  display: none;
}
.detailContainer .detailContent .content2 .flightContainer.selected .flightContent .flightList {
  border: 2px solid #386DFF;
}
.detailContainer .detailContent .content2 .flightContainer.cancelled .flightContent .flightList {
  border: 2px solid #D80909;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent {
  padding: 10px;
  display: flex;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent {
  display: flex;
  align-items: center;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .dotIcon {
  background: #4B5F7A;
  border: 2px solid #384D69;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  position: relative;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .dotIcon::after {
  content: "";
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 117px;
  background-color: #2A3A4F;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .mixedLine {
  height: 117px;
  position: relative;
  right: 7px;
  top: 50px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .mixedLine .mixedLineSolid {
  border: 1px solid #2A3A4F;
  height: 50%;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .mixedLine .mixedLineDashed {
  height: 50%;
  background: repeating-linear-gradient(to bottom, #2A3A4F, #2A3A4F 5px, transparent 4px, transparent 10px);
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList {
  border: 1.5px solid #4B5F7A;
  border-radius: 6px;
  width: 337px;
  margin: 0px 8px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader {
  background: #1C2633;
  border-radius: 6px;
  display: flex;
  align-items: center;
  height: 30px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerLeft {
  width: 50%;
  text-align: left;
  color: #FDFDFD;
  padding: 0px 8px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerLeft .airlineId {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerLeft .airlineTime {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  text-align: right;
  padding-left: 8px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerRight {
  margin: 2px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 20px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerRight.success {
  color: #55FC7F;
  border: 1px solid #84FFA3;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerRight.fail {
  background-color: #D80909;
  border: 1px solid #D80909;
  color: #FDFDFD;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation {
  display: flex;
  padding: 8px 0px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .location {
  width: 33%;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .location .airportCode {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A9BBC7;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .location .airportTime {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .arrow {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .arrow .arrowLine {
  width: 26px;
  height: 1px;
  border: 1px solid #4B5F7A;
  margin: 0px 6px;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  width: 235px;
  height: 28px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText.normal {
  background: #1C2633;
  color: #A9BBC7;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText.normal.location {
  border: 2px solid #386DFF;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText.success {
  background: #FFB8B8;
  color: #384D69;
}
.warning-icon {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}
.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #2A3A4F;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.loading-spinner.airport {
  border-top-color: #465569;
}
.loading-spinner.with-issue {
  border-top-color: #FB4B4B;
}
.loading-spinner.no-issue {
  border-top-color: #09AF91;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.no-trip-details {
  opacity: 0.8;
  padding: 20px 0;
  text-align: center;
}
.trip-details-header {
  display: flex;
}
.trip-details-header .trip-info {
  width: 25%;
  border-right: 1.5px solid #2A3A4F;
  padding: 5px 0;
}
.trip-details-header .passenger-info {
  width: 75%;
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.trip-details-header .passenger-info .passengerBox {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.dashed-divider {
  height: 1.5px;
  background: repeating-linear-gradient(to right, #2A3A4F, #2A3A4F 10px, transparent 4px, transparent 20px);
}
.current-flight-location {
  display: flex;
}
.current-flight-location .location-column {
  border-bottom: 1.5px solid #2A3A4F;
  padding: 16px 0 7px 0;
  width: 45%;
  display: flex;
}
.current-flight-location .location-column .location-details {
  width: 85%;
}
.current-flight-location .location-column .location-airport-code {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #FDFDFD;
}
.current-flight-location .location-column .location-city {
  text-align: center;
}
.current-flight-location .location-column .location-divider-container {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.current-flight-location .location-column .location-divider {
  border: 1px solid #2A3A4F;
  width: 100%;
}
.current-flight-location .flight-direction-arrow {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.current-flight-time {
  display: flex;
}
.current-flight-time .time-column {
  width: 45%;
  display: flex;
}
.current-flight-time .time-group {
  padding-top: 10px;
  width: 85%;
}
.current-flight-time .time-group.scheduled {
  border-right: 1.5px solid #2A3A4F;
  margin-right: 8px;
}
.current-flight-time .time-label {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: #8998AB;
  display: flex;
  align-items: center;
  gap: 4px;
}
.current-flight-time .time-value-container {
  display: flex;
}
.current-flight-time .time-value {
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #FDFDFD;
}
.current-flight-time .time-value.delayed {
  color: #FF4C4C;
}
.current-flight-time .time-period {
  font-weight: 500;
  font-size: 11px;
  line-height: 22px;
  color: #FDFDFD;
  margin-left: 2px;
}
.current-flight-time .time-period.delayed {
  color: #FF4C4C;
}
.delayed-indicator {
  position: relative;
  display: inline-block;
  margin-left: 4px;
}
.delayed-indicator .delay-triangle {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid #FF4C4C;
  display: inline-block;
}
.delayed-indicator .delay-triangle-icon {
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  color: black;
  font-size: 7px;
  font-weight: bold;
  line-height: 1;
  pointer-events: none;
}
.flight-card-list {
  background: #121B26;
  border-radius: 32px 32px 0px 0px;
  padding: 10px;
  margin-top: 10px;
  margin-right: 6px;
  position: relative;
}
.flight-card-wrapper {
  padding: 10px;
}
.flight-card {
  display: flex;
}
.flight-card__timeline {
  display: flex;
  align-items: center;
}
.flight-card__dot {
  background: white;
  width: 13px;
  height: 13px;
  border-radius: 50%;
}
.flight-card__dot--completed {
  border: 3px solid #6B7280;
  opacity: 0.5;
}
.flight-card__dot--current {
  border: 3px solid #386DFF;
}
.flight-card__dot--future {
  border: 3px solid #9CA3AF;
}
.flight-card__main {
  border-radius: 6px;
  width: 337px;
  margin: 0 8px;
}
.flight-card__main--completed {
  border: 1.5px solid #6B7280;
  opacity: 0.5;
}
.flight-card__main--current {
  border: 1.5px solid #386DFF;
}
.flight-card__main--future-with-issue {
  border: 1.5px solid #FF4C4C;
}
.flight-card__main--future-no-issue {
  border: 1.5px solid #4B5F7A;
}
.flight-card__header {
  background: #1C2633;
  border-radius: 6px;
  display: flex;
  align-items: center;
  height: 30px;
}
.flight-card__flight-info {
  width: 50%;
  text-align: left;
  color: #FDFDFD;
  padding: 0 8px;
}
.flight-card__flight-number {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
}
.flight-card__flight-date {
  font-weight: 350;
  font-size: 9px;
  line-height: 14px;
  text-align: right;
  padding-left: 8px;
}
.flight-card__status {
  margin: 2px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 20px;
  border-radius: 12px;
  font-weight: 700;
  line-height: 12px;
  text-transform: uppercase;
}
.flight-card__status--with-issue {
  color: #FFFFFF;
  border: 1px solid #FF4C4C;
  background-color: #FF4C4C;
}
.flight-card__status--no-issue {
  color: #55FC7F;
  border: 1px solid #84FFA3;
  background-color: transparent;
}
.flight-card__details {
  display: flex;
  padding: 8px 0;
}
.flight-card__airport-info {
  width: 33%;
}
.flight-card__airport-info--departure {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}
.flight-card__airport-code {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A9BBC7;
}
.flight-card__time {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
}
.flight-card__separator {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flight-card__separator-line {
  width: 26px;
  height: 1px;
  border: 1px solid #4B5F7A;
  margin: 0 6px;
}
.connection-info-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.connection-info {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  width: 235px;
  height: 28px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.connection-info--with-issue {
  background: #FFB3B3;
  color: #FFFFFF;
}
.connection-info--no-issue {
  background: #1C2633;
  color: #A9BBC7;
}
.connection-info--passenger-waiting {
  border: 2px solid #4A90E2;
}
.textIcon {
  position: relative;
  left: 5px;
  top: 1px;
}
.textAlignRight {
  text-align: right;
}
.textAlignLeft {
  text-align: left;
}
.flightContainer.selected ~ .flightContainer .dotIcon {
  background: #FFFFFF !important;
  border: 2px solid #8998AB !important;
}
.cursor-pointer {
  cursor: pointer;
}
.passenger-selected {
  background-color: #2A3A4F !important;
  border: 1px solid #1C2633;
  border-radius: 8px;
  width: fit-content;
}
.scrollContent::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}
.scrollContent::-webkit-scrollbar-track {
  background: transparent;
}
.scrollContent::-webkit-scrollbar-thumb {
  background: #4B5F7A;
  border-radius: 4px;
}
.scrollContent::-webkit-scrollbar-thumb:hover {
  background: #3a4b60;
}
.scrollContent::-webkit-scrollbar-corner {
  background: transparent;
  display: none;
}
/* Apply same scrollbar styles to locationContent for airport popups */
.locationContent::-webkit-scrollbar,
.locationContent.scrollContent::-webkit-scrollbar {
  width: 3px !important;
  height: 3px !important;
}
.locationContent::-webkit-scrollbar-track,
.locationContent.scrollContent::-webkit-scrollbar-track {
  background: transparent !important;
}
.locationContent::-webkit-scrollbar-thumb,
.locationContent.scrollContent::-webkit-scrollbar-thumb {
  background: #4B5F7A !important;
  border-radius: 4px !important;
}
.locationContent::-webkit-scrollbar-thumb:hover,
.locationContent.scrollContent::-webkit-scrollbar-thumb:hover {
  background: #3a4b60 !important;
}
.locationContent::-webkit-scrollbar-corner,
.locationContent.scrollContent::-webkit-scrollbar-corner {
  background: transparent !important;
  display: none !important;
}
.passenger-card {
  padding-block: 4px;
  min-width: 190px;
}
.passenger-card:first-child {
  margin-top: 0px !important;
}
.multi-passenger-wrapper {
  display: flex;
  align-items: center;
}
.multi-passenger-wrapper > * {
  flex-shrink: 0;
}
.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}
.no-data-state {
  opacity: 0.8;
  padding: 20px 0;
  text-align: center;
}
.trip-detail-header {
  display: flex;
}
.trip-info-column {
  width: 25%;
  border-right: 1.5px solid #2A3A4F;
  padding: 5px 0;
}
.passenger-info-column {
  width: 75%;
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.passenger-info-column .passengerBox {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.time-row {
  display: flex;
}
.time-column {
  width: 45%;
  display: flex;
}
.time-group {
  padding-top: 10px;
  width: 85%;
}
.time-group.with-border {
  border-right: 1.5px solid #2A3A4F;
  margin-right: 8px;
}
.time-label {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: #8998AB;
  display: flex;
  align-items: center;
  gap: 4px;
}
.time-value-display {
  display: flex;
  align-items: center;
}
.time-value-display .time {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #FDFDFD;
}
.time-value-display .time.delayed {
  color: #FF6B6B;
}
.time-value-display .period {
  font-weight: 500;
  font-size: 10px;
  line-height: 22px;
  color: #708299;
  margin-left: 4px;
}
.time-value-display .period.delayed {
  color: #FF6B6B;
}
.location-row {
  display: flex;
}
.location-column {
  border-bottom: 1.5px solid var(--bg-divider);
  padding: 16px 0;
  width: 45%;
  display: flex;
}
.location-column .location-info {
  width: 85%;
}
.location-column .location-code {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #FDFDFD;
}
.location-column .passengerLabel {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A9BBC7;
}
.location-column .divider-container {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.location-column .divider-container .divider {
  border: 1px solid #2A3A4F;
  width: 100%;
}
.arrow-column {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4B5F7A;
}
.leg-description {
  padding: 10px 0;
  color: #FDFDFD;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  gap: 4px;
  font-style: normal;
  font-family: Montserrat;
}
.leg-description .leg-description-label {
  font-weight: 400;
}
.leg-description .leg-description-number {
  font-weight: 700;
}
.leg-description .leg-description-value {
  font-weight: 700;
}
.dashed-divider {
  height: 1.5px;
  background: repeating-linear-gradient(to right, #2A3A4F, #2A3A4F 10px, transparent 4px, transparent 20px);
}
.flight-cards-container {
  background: var(--bg-secondary);
  border-radius: var(--radius-2xl) var(--radius-2xl) 0 0;
  padding: var(--spacing-md);
  margin-top: var(--spacing-md);
  margin-right: 6px;
  position: relative;
}
.flight-card {
  padding: var(--spacing-md);
}
.flight-card__header {
  display: flex;
  align-items: center;
}
.flight-card__circle {
  background: white;
  width: var(--flight-card-circle-size);
  height: var(--flight-card-circle-size);
  border-radius: 50%;
}
.flight-card__circle--completed {
  border: 3px solid var(--border-disabled);
  opacity: 0.5;
}
.flight-card__circle--current {
  border: 3px solid var(--color-primary-blue);
  opacity: 1;
}
.flight-card__circle--future {
  border: 3px solid var(--border-future);
  opacity: 1;
}
.flight-card__content {
  border-radius: var(--radius-md);
  width: var(--flight-card-width);
  margin: 0 var(--spacing-sm);
}
.flight-card__content--completed {
  border: 1.5px solid var(--border-disabled);
  opacity: 0.5;
}
.flight-card__content--current {
  border: 1.5px solid var(--color-primary-blue);
  opacity: 1;
}
.flight-card__content--future {
  border: 1.5px solid var(--border-primary);
  opacity: 1;
}
.flight-card__info-bar {
  background: var(--bg-primary);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  height: 30px;
}
.flight-card__flight-number {
  width: 50%;
  text-align: left;
  color: var(--text-primary);
  padding: 0 var(--spacing-sm);
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
}
.flight-card__flight-date {
  font-weight: 350;
  font-size: 9px;
  line-height: 14px;
  text-align: right;
  padding-left: var(--spacing-sm);
}
.flight-card__status-badge {
  margin: 2px var(--spacing-sm);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 20px;
  border-radius: var(--radius-xl);
  font-weight: 700;
  line-height: 12px;
  text-transform: uppercase;
}
.flight-card__route {
  display: flex;
  padding: var(--spacing-sm) 0;
}
.flight-card__airport {
  width: 33%;
}
.flight-card__airport--departure {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}
.flight-card__airport--arrival {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.flight-card__airport-code {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-tertiary);
}
.flight-card__flight-time {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-primary);
}
.flight-card__route-divider {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flight-card__route-divider .line {
  width: 26px;
  height: 1px;
  border: 1px solid var(--border-primary);
  margin: 0 6px;
}
.connection-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
}
.connection-indicator__badge {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-sm) 24px;
  width: var(--connection-indicator-width);
  height: var(--connection-indicator-height);
  border-radius: var(--radius-sm);
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.connection-indicator__badge--normal {
  background: var(--bg-primary);
  color: var(--text-tertiary);
  border: none;
}
.connection-indicator__badge--issue {
  background: var(--status-red-bg);
  color: var(--text-primary);
  border: none;
  font-weight: 700;
}
.connection-indicator__badge--waiting {
  background: var(--bg-primary);
  color: var(--text-tertiary);
  border: 2px solid var(--color-primary-blue);
  font-weight: 700;
}
.connection-line {
  position: absolute;
  width: 1px;
  pointer-events: none;
  z-index: 1;
}
.connection-line--solid {
  background: var(--border-primary);
}
.connection-line--dotted {
  background: transparent;
  background-image: repeating-linear-gradient(to bottom, var(--border-primary) 0px, var(--border-primary) 8px, transparent 8px, transparent 10px);
}
.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
}
.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--bg-divider);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.loading-spinner--success {
  border-top-color: var(--color-success);
}
.loading-spinner--error {
  border-top-color: var(--color-error-secondary);
}
.loading-spinner--airport {
  border-top-color: #465569ff;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.no-data-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
  color: #A9BBC7;
}
.delay-warning {
  position: relative;
  display: inline-block;
}
.delay-warning__triangle {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid #FF6B6B;
  display: inline-block;
  border-radius: 3px;
}
.delay-warning__exclamation {
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  color: black;
  font-size: 9px;
  font-weight: bold;
  line-height: 1;
  pointer-events: none;
}
.warning-icon {
  display: inline-flex;
  align-items: center;
  margin-left: var(--spacing-sm);
}
.trip-detail-header {
  display: flex;
}
.trip-detail-header .trip-info-column {
  width: 25%;
  border-right: 1.5px solid var(--bg-divider);
  padding: 5px 0;
}
.trip-detail-header .trip-info-column .passengerLabel {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A9BBC7;
}
.trip-detail-header .passenger-info-column {
  width: 75%;
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.trip-id-link {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #386DFF;
  cursor: pointer;
}
.trip-external-link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  margin-left: 6px;
  color: #B8C3D1;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.2s ease;
}
.trip-external-link-btn:hover {
  opacity: 0.8;
}
.trip-external-link-btn svg {
  width: 14px;
  height: 14px;
}
.trip-id-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: var(--text-primary);
}
[data-tooltip] {
  position: relative;
}
[data-tooltip]:hover::after {
  content: attr(data-tooltip);
  position: fixed;
  z-index: 99999;
  background-color: #2d3748;
  color: #ffffff;
  padding: 6px 12px;
  font-size: 11px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  opacity: 1;
  border: 1px solid #4a5568;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  left: var(--mouse-x, 0px);
  top: var(--mouse-y, 0px);
  transform: translate(15px, 5px);
}
`, "",{"version":3,"sources":["webpack://./src/js/map/style/flight.less"],"names":[],"mappings":"AACA;EAEI,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,+BAAA;EAGA,wBAAA;EACA,sBAAA;EACA,gCAAA;EACA,wBAAA;EACA,6BAAA;EAGA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EAGA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,oBAAA;EAGA,yBAAA;EACA,0BAAA;EACA,wBAAA;EAGA,uBAAA;EACA,8BAAA;EACA,wBAAA;EAGA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAGA,0BAAA;EACA,+BAAA;EACA,mCAAA;EACA,mCAAA;AAjBJ;AAoBA;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sEAAA;AAlBJ;AAoBI;EACI,sCAAA;AAlBR;AAqBI;EACI,oCAAA;AAnBR;AAIA;EAmBQ,0BAAA;EACA,kBAAA;AApBR;AAsBQ;EACI,gCAAA;AApBZ;AAuBQ;EACI,8BAAA;AArBZ;AANA;EA+BY,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;AAtBZ;AAdA;EAuCgB,iBAAA;AAtBhB;AAjBA;EA6CQ,OAAA;EACA,4CAAA;EACA,0BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;AAzBR;AAzBA;EAqDY,eAAA;EACA,iBAAA;EACA,gBAAA;AAzBZ;AA9BA;EA0DgB,kBAAA;EACA,mBAAA;AAzBhB;AAlCA;EAgEY,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA3BZ;AAzCA;EAuEgB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA3BhB;AAiCA;EACI,eAAA;EACA,aAAA;EACA,oBAAA;EACA,sEAAA;AA/BJ;AAkCA;EACI,gBAAA;EACA,mBAAA;AAhCJ;AA8BA;EAKQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAhCR;AAkCQ;EACI,mBAAA;AAhCZ;AAoBA;EAgBY,cAAA;EACA,cAAA;AAjCZ;AAgBA;EAqBY,cAAA;EACA,kBAAA;EACA,mBAAA;AAlCZ;AAuCA;EACI,gBAAA;AArCJ;AAwCA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAtCJ;AAwCI;EACI,yBAAA;AAtCR;AA2BA;EAeQ,YAAA;EACA,kBAAA;EACA,mBAAA;AAvCR;AAyCQ;EACI,mBAAA;AAvCZ;AAmBA;EAwBY,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAxCZ;AAWA;EAgCgB,iBAAA;AAxChB;AAQA;EAsCQ,OAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA3CR;AAAA;EA8CY,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA3CZ;AANA;EAqDY,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA5CZ;AAbA;EA6DY,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA7CZ;AAkDA;EACI,kBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,sEAAA;EACA,YAAA;AAjDJ;AAmDI;EACI,SAAA;AAjDR;AAoDI;EACI,yBAAA;AAlDR;AAqDI;EACI,yBAAA;AAnDR;AA4BA;EA2BQ,YAAA;EACA,kBAAA;AApDR;AAsDQ;EACI,mBAAA;AApDZ;AAuDQ;EACI,mBAAA;AArDZ;AAkBA;EAuCY,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAtDZ;AAUA;EA+CgB,iBAAA;AAtDhB;AAOA;EAqDQ,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAzDR;AADA;EA6DY,aAAA;EACA,gBAAA;AAzDZ;AALA;EAiEgB,aAAA;AAzDhB;AARA;EAoEoB,UAAA;EACA,iCAAA;EACA,gBAAA;AAzDpB;AAbA;EAyEwB,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzDxB;AAnBA;EAgFwB,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,cAAA;AA1DxB;AA5BA;EA2FoB,UAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AA5DpB;AAlCA;EAmGgB,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA9DhB;AA5CA;EA8GgB,aAAA;EACA,yGAAA;AA/DhB;AAhDA;EAuHgB,aAAA;AApEhB;AAnDA;EA0HoB,kCAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;AApEpB;AAzDA;EAgIwB,UAAA;AApExB;AA5DA;EAmI4B,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AApE5B;AAnEA;EA2I4B,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AArE5B;AA1EA;EAoJwB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvExB;AAhFA;EA0J4B,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvE5B;AAvFA;EAoKoB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1EpB;AA7FA;EA4KgB,aAAA;AA5EhB;AAhGA;EA+KoB,UAAA;EACA,aAAA;AA5EpB;AApGA;EAmLwB,iBAAA;EACA,UAAA;AA5ExB;AA8EwB;EACI,iCAAA;EACA,iBAAA;AA5E5B;AA5GA;EA4L4B,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7E5B;AAlHA;EAmM4B,aAAA;AA9E5B;AArHA;EAsMgC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9EhC;AA3HA;EA6MgC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AA/EhC;AArIA;EA2NoB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnFpB;AA3IA;EAoOY,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AAtFZ;AAyFgB;EAEQ,aAAA;AAxFxB;AA4FgB;EAIgB,mBAAA;EACA,yBAAA;AA7FhC;AA+FgC;EACI,aAAA;AA7FpC;AAqFgB;EAcY,yBAAA;AAhG5B;AAqGgB;EAGY,yBAAA;AArG5B;AAlKA;EA6QoB,aAAA;EACA,aAAA;AAxGpB;AAtKA;EAiRwB,aAAA;EACA,mBAAA;AAxGxB;AA1KA;EAqR4B,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAxG5B;AA0G4B;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAxGhC;AA5LA;EAyS4B,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AA1G5B;AAlMA;EA+SgC,yBAAA;EACA,WAAA;AA1GhC;AAtMA;EAoTgC,WAAA;EACA,yGAAA;AA3GhC;AA1MA;EA2TwB,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AA9GxB;AAhNA;EAiU4B,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA9G5B;AAvNA;EAwUgC,UAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA9GhC;AA7NA;EA8UoC,gBAAA;EACA,eAAA;EACA,iBAAA;AA9GpC;AAlOA;EAoVoC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AA/GpC;AAzOA;EA6VgC,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAjHhC;AAmHgC;EACI,cAAA;EACA,yBAAA;AAjHpC;AAoHgC;EACI,yBAAA;EACA,yBAAA;EACA,cAAA;AAlHpC;AA/PA;EAuX4B,aAAA;EACA,gBAAA;AArH5B;AAnQA;EA2XgC,UAAA;AArHhC;AAtQA;EA8XoC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArHpC;AA5QA;EAqYoC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtHpC;AAlRA;EA6YgC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxHhC;AAxRA;EAmZoC,WAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;AAxHpC;AA9RA;EA8ZoB,aAAA;EACA,uBAAA;EACA,mBAAA;AA7HpB;AAnSA;EAmawB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA7HxB;AA+HwB;EACI,mBAAA;EACA,cAAA;AA7H5B;AA+H4B;EACI,yBAAA;AA7HhC;AAiIwB;EACI,mBAAA;EACA,cAAA;AA/H5B;AAwIA;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;AAtIJ;AAyIA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAvIJ;AA0IA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;AAxIJ;AA0II;EACI,yBAAA;AAxIR;AA2II;EACI,yBAAA;AAzIR;AA4II;EACI,yBAAA;AA1IR;AA8IA;EACI;IACI,uBAAA;EA5IN;EA+IE;IACI,yBAAA;EA7IN;AACF;AAgJA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;AA9IJ;AAiJA;EACI,aAAA;AA/IJ;AA8IA;EAIQ,UAAA;EACA,iCAAA;EACA,cAAA;AA/IR;AAyIA;EA+BQ,UAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AArKR;AAmIA;EAqCY,aAAA;EACA,sBAAA;EACA,qBAAA;AArKZ;AA4LA;EACI,aAAA;EACA,yGAAA;AA1LJ;AA6LA;EACI,aAAA;AA3LJ;AA0LA;EAIQ,kCAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;AA3LR;AAoLA;EAUY,UAAA;AA3LZ;AAiLA;EAcY,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA5LZ;AA0KA;EAsBY,kBAAA;AA7LZ;AAuKA;EA0BY,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9LZ;AAiKA;EAiCY,yBAAA;EACA,WAAA;AA/LZ;AA6JA;EAuCQ,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjMR;AAqMA;EACI,aAAA;AAnMJ;AAkMA;EAIQ,UAAA;EACA,aAAA;AAnMR;AA8LA;EASQ,iBAAA;EACA,UAAA;AApMR;AAsMQ;EACI,iCAAA;EACA,iBAAA;AApMZ;AAsLA;EAmBQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAtMR;AA6KA;EA6BQ,aAAA;AAvMR;AA0KA;EAiCQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxMR;AA0MQ;EACI,cAAA;AAxMZ;AAiKA;EA4CQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AA1MR;AA4MQ;EACI,cAAA;AA1MZ;AA+MA;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;AA7MJ;AA0MA;EAMQ,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,qBAAA;AA7MR;AAkMA;EAeQ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AA9MR;AAkNA;EACI,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAhNJ;AAmNA;EACI,aAAA;AAjNJ;AAoNA;EACI,aAAA;AAlNJ;AAoNI;EACI,aAAA;EACA,mBAAA;AAlNR;AAqNI;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAnNR;AAqNQ;EACI,yBAAA;EACA,YAAA;AAnNZ;AAsNQ;EACI,yBAAA;AApNZ;AAuNQ;EACI,yBAAA;AArNZ;AAyNI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;AAvNR;AAyNQ;EACI,2BAAA;EACA,YAAA;AAvNZ;AA0NQ;EACI,2BAAA;AAxNZ;AA2NQ;EACI,2BAAA;AAzNZ;AA4NQ;EACI,2BAAA;AA1NZ;AA8NI;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA5NR;AA+NI;EACI,UAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AA7NR;AAgOI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AA9NR;AAiOI;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AA/NR;AAkOI;EACI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAhOR;AAkOQ;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;AAhOZ;AAmOQ;EACI,cAAA;EACA,yBAAA;EACA,6BAAA;AAjOZ;AAqOI;EACI,aAAA;EACA,cAAA;AAnOR;AAsOI;EACI,UAAA;AApOR;AAsOQ;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AApOZ;AAwOI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtOR;AAyOI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvOR;AA0OI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxOR;AA2OI;EACI,WAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;AAzOR;AA6OA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AA3OJ;AA8OA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA5OJ;AA8OI;EACI,mBAAA;EACA,cAAA;AA5OR;AA+OI;EACI,mBAAA;EACA,cAAA;AA7OR;AAgPI;EACI,yBAAA;AA9OR;AAkPA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AAhPJ;AAmPA;EACI,iBAAA;AAjPJ;AAoPA;EACI,gBAAA;AAlPJ;AAqPA;EACI,8BAAA;EACA,oCAAA;AAnPJ;AAsPA;EACI,eAAA;AApPJ;AAuPA;EACI,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AArPJ;AAwPA;EACI,UAAA;EACA,WAAA;AAtPJ;AAyPA;EACI,uBAAA;AAvPJ;AA0PA;EACI,mBAAA;EACA,kBAAA;AAxPJ;AA2PA;EACI,mBAAA;AAzPJ;AA4PA;EACI,uBAAA;EACA,aAAA;AA1PJ;AACA,sEAAsE;AA6PtE;;EAEI,qBAAA;EACA,sBAAA;AA3PJ;AA8PA;;EAEI,kCAAA;AA5PJ;AA+PA;;EAEI,8BAAA;EACA,6BAAA;AA7PJ;AAgQA;;EAEI,8BAAA;AA9PJ;AAiQA;;EAEI,kCAAA;EACA,wBAAA;AA/PJ;AAkQA;EACI,kBAAA;EACA,gBAAA;AAhQJ;AAmQA;EACI,0BAAA;AAjQJ;AAoQA;EACI,aAAA;EACA,mBAAA;AAlQJ;AAqQA;EACI,cAAA;AAnQJ;AAyQA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAvQJ;AA0QA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;AAxQJ;AA4QA;EACI,aAAA;AA1QJ;AA6QA;EACI,UAAA;EACA,iCAAA;EACA,cAAA;AA3QJ;AA8QA;EACI,UAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AA5QJ;AAwQA;EAOQ,aAAA;EACA,sBAAA;EACA,qBAAA;AA5QR;AAiRA;EACI,aAAA;AA/QJ;AAmRA;EACI,UAAA;EACA,aAAA;AAjRJ;AAoRA;EACI,iBAAA;EACA,UAAA;AAlRJ;AAoRI;EACI,iCAAA;EACA,iBAAA;AAlRR;AAsRA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AApRJ;AAuRA;EACI,aAAA;EACA,mBAAA;AArRJ;AAmRA;EAKQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArRR;AAuRQ;EACI,cAAA;AArRZ;AA0QA;EAgBQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAvRR;AAyRQ;EACI,cAAA;AAvRZ;AA6RA;EACI,aAAA;AA3RJ;AA8RA;EACI,4CAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AA5RJ;AAwRA;EAOQ,UAAA;AA5RR;AAqRA;EAWQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA7RR;AA8QA;EAmBQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9RR;AAwQA;EA0BQ,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/RR;AAkQA;EAgCY,yBAAA;EACA,WAAA;AA/RZ;AAoSA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAlSJ;AAsSA;EACI,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,uBAAA;AApSJ;AA2RA;EAYQ,gBAAA;AApSR;AAwRA;EAgBQ,gBAAA;AArSR;AAqRA;EAoBQ,gBAAA;AAtSR;AA2SA;EACI,aAAA;EACA,yGAAA;AAzSJ;AA6SA;EACI,+BAAA;EACA,sDAAA;EACA,0BAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;AA3SJ;AA+SA;EACI,0BAAA;AA7SJ;AA+SI;EACI,aAAA;EACA,mBAAA;AA7SR;AAgTI;EACI,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,kBAAA;AA9SR;AAgTQ;EACI,wCAAA;EACA,YAAA;AA9SZ;AAiTQ;EACI,2CAAA;EACA,UAAA;AA/SZ;AAkTQ;EACI,sCAAA;EACA,UAAA;AAhTZ;AAoTI;EACI,+BAAA;EACA,+BAAA;EACA,2BAAA;AAlTR;AAoTQ;EACI,0CAAA;EACA,YAAA;AAlTZ;AAqTQ;EACI,6CAAA;EACA,UAAA;AAnTZ;AAsTQ;EACI,yCAAA;EACA,UAAA;AApTZ;AAwTI;EACI,6BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAtTR;AAyTI;EACI,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAvTR;AA0TI;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,+BAAA;AAxTR;AA2TI;EACI,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzTR;AA4TI;EACI,aAAA;EACA,4BAAA;AA1TR;AA6TI;EACI,UAAA;AA3TR;AA6TQ;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AA3TZ;AA8TQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AA5TZ;AAgUI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AA9TR;AAiUI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AA/TR;AAkUI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhUR;AA4TI;EAOQ,WAAA;EACA,WAAA;EACA,uCAAA;EACA,aAAA;AAhUZ;AAsUA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AApUJ;AAsUI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,wCAAA;EACA,0CAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AApUR;AAsUQ;EACI,6BAAA;EACA,2BAAA;EACA,YAAA;AApUZ;AAuUQ;EACI,gCAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;AArUZ;AAwUQ;EACI,6BAAA;EACA,2BAAA;EACA,2CAAA;EACA,gBAAA;AAtUZ;AA4UA;EACI,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,UAAA;AA1UJ;AA4UI;EACI,iCAAA;AA1UR;AA6UI;EACI,uBAAA;EACA,+IAAA;AA3UR;AAoVA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAlVJ;AAqVA;EACI,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AAnVJ;AAqVI;EACI,sCAAA;AAnVR;AAsVI;EACI,8CAAA;AApVR;AAuVI;EACI,2BAAA;AArVR;AAyVA;EACI;IACI,uBAAA;EAvVN;EA0VE;IACI,yBAAA;EAxVN;AACF;AA4VA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA1VJ;AA8VA;EACI,kBAAA;EACA,qBAAA;AA5VJ;AA8VI;EACI,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,qBAAA;EACA,kBAAA;AA5VR;AA+VI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AA7VR;AAkWA;EACI,oBAAA;EACA,mBAAA;EACA,8BAAA;AAhWJ;AAoWA;EACI,aAAA;AAlWJ;AAiWA;EAIQ,UAAA;EACA,2CAAA;EACA,cAAA;AAlWR;AA4VA;EASY,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlWZ;AAsVA;EAiBQ,UAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AApWR;AAyWA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AAvWJ;AA0WA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,6BAAA;AAxWJ;AA0WI;EACI,YAAA;AAxWR;AA2VA;EAiBQ,WAAA;EACA,YAAA;AAzWR;AA6WA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AA3WJ;AA+WA;EACI,kBAAA;AA7WJ;AAgXA;EACI,2BAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,4DAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,wBAAA;EACA,+BAAA;AA9WJ","sourcesContent":["// CSS Variables for Flight Popup\n:root {\n    // Popup Dimensions\n    --hover-popup-width: 220px;\n    --detail-popup-width: 405px;\n    --detail-popup-height: 506px;\n    --detail-content-height: 450px;\n    --popup-offset: 20px;\n    --popup-spacing: 5px;\n    --hover-popup-max-height: 248px;\n\n    // Colors - Primary\n    --color-success: #09AF91;\n    --color-error: #FB4B4B;\n    --color-error-secondary: #FF4C4C;\n    --color-warning: #FFD700;\n    --color-primary-blue: #386DFF;\n\n    // Colors - Backgrounds\n    --bg-primary: #1C2633;\n    --bg-secondary: #121B26;\n    --bg-card: #0D1117;\n    --bg-divider: #2A3A4F;\n\n    // Colors - Text\n    --text-primary: #FDFDFD;\n    --text-secondary: #708299;\n    --text-tertiary: #A9BBC7;\n    --text-code: #8998AB;\n\n    // Colors - Borders\n    --border-primary: #4B5F7A;\n    --border-disabled: #6B7280;\n    --border-future: #9CA3AF;\n\n    // Colors - Status\n    --status-green: #55FC7F;\n    --status-green-border: #84FFA3;\n    --status-red-bg: #FFB3B3;\n\n    // Spacing\n    --spacing-xs: 4px;\n    --spacing-sm: 8px;\n    --spacing-md: 10px;\n    --spacing-lg: 12px;\n\n    // Border Radius\n    --radius-sm: 4px;\n    --radius-md: 6px;\n    --radius-lg: 8px;\n    --radius-xl: 12px;\n    --radius-2xl: 32px;\n\n    // Flight Card Dimensions\n    --flight-card-width: 337px;\n    --flight-card-circle-size: 13px;\n    --connection-indicator-width: 235px;\n    --connection-indicator-height: 28px;\n}\n\n.hoverContainer {\n    position: relative;\n    width: 215px;\n    background: var(--bg-primary);\n    border-radius: var(--radius-lg);\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n\n    &.withoutIssue {\n        border: 3px solid var(--color-success);\n    }\n\n    &.withIssue {\n        border: 3px solid var(--color-error);\n    }\n\n    .hoverHeader {\n        padding: var(--spacing-sm);\n        text-align: center;\n\n        &.withoutIssue {\n            background: var(--color-success);\n        }\n\n        &.withIssue {\n            background: var(--color-error);\n        }\n\n        .headerText {\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 16px;\n            color: var(--text-primary);\n            margin: 0 auto;\n            width: fit-content;\n\n            .textView {\n                padding-left: 3px;\n            }\n        }\n    }\n\n    .hoverContent {\n        flex: 1;\n        padding: var(--spacing-sm) var(--spacing-lg);\n        color: var(--text-primary);\n        padding-right: var(--spacing-xs);\n        margin-right: 3px;\n        overflow-x: hidden;\n\n        .contentText {\n            font-size: 20px;\n            line-height: 24px;\n            font-weight: 500;\n\n            .hoverArrow {\n                padding-left: 10px;\n                padding-right: 10px;\n            }\n        }\n\n        .passenger-parent {\n            max-height: 150px;\n            overflow-y: auto;\n            overflow-x: auto;\n            padding-right: 4px;\n            margin-top: 6px;\n\n            .multiplePassenger {\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                padding: 4px 8px;\n                background: #0D1117;\n                border: 1px solid #1C2633;\n                border-radius: 8px;\n                margin-top: 6px;\n            }\n        }\n    }\n}\n\n.popup-base {\n    position: fixed;\n    z-index: 9999;\n    pointer-events: auto;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.passengerBox {\n    padding-top: 5px;\n    padding-bottom: 5px;\n\n    .passengerContainer {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        display: flex;\n        white-space: nowrap;\n\n        &:first-child {\n            padding-bottom: 2px;\n        }\n\n        .passengerLabel {\n            color: #A9BBC7;\n            flex-shrink: 0;\n        }\n\n        .passengerValue {\n            color: #FDFDFD;\n            padding-left: 10px;\n            white-space: nowrap;\n        }\n    }\n}\n\n.passenger-card {\n    min-width: 190px;\n}\n\n.locationContainer {\n    position: relative;\n    width: 215px;\n    background: #1C2633;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    border: 3px solid #2A3A4F;\n    overflow-x: hidden;\n\n    &.passengerClick {\n        border: 3px solid #09AF91;\n    }\n\n    .locationHeader {\n        padding: 8px;\n        text-align: center;\n        background: #2A3A4F;\n\n        &.passengerClick {\n            background: #09AF91;\n        }\n\n        .headerText {\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 16px;\n            color: #FDFDFD;\n            margin: 0 auto;\n            width: fit-content;\n\n            .textView {\n                padding-left: 3px;\n            }\n        }\n    }\n\n    .locationContent {\n        flex: 1;\n        margin: 8px 12px;\n        color: #FDFDFD;\n        padding-right: 4px;\n        margin-right: 3px;\n        overflow-x: hidden;\n\n        .contentText {\n            font-size: 12px;\n            line-height: 16px;\n            font-weight: 500;\n            text-align: center;\n        }\n\n        .passenger-parent {\n            max-height: 150px;\n            overflow-y: auto;\n            overflow-x: auto;\n            padding-right: 4px;\n            margin-top: 6px;\n        }\n\n        .multiplePassenger {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            padding: 4px 8px;\n            background: #0D1117;\n            border: 1px solid #1C2633;\n            border-radius: 8px;\n            margin-top: 6px;\n        }\n    }\n}\n\n.detailContainer {\n    position: relative;\n    width: 405px;\n    background: #1C2633;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    height: 506px;\n    max-height: 506px;\n    overflow-y: auto;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n    width: 405px;\n\n    &.multiplePassenger {\n        left: 5px;\n    }\n\n    &.withoutIssue {\n        border: 3px solid #09AF91;\n    }\n\n    &.withIssue {\n        border: 3px solid #FB4B4B;\n    }\n\n    .detailHeader {\n        padding: 6px;\n        text-align: center;\n\n        &.withoutIssue {\n            background: #09AF91;\n        }\n\n        &.withIssue {\n            background: #FB4B4B;\n        }\n\n        .headerText {\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 16px;\n            color: #FDFDFD;\n            margin: 0 auto;\n            width: fit-content;\n\n            .textView {\n                padding-left: 3px;\n            }\n        }\n    }\n\n    .detailContent {\n        max-height: 450px;\n        height: 450px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        margin-right: 6px;\n        margin-top: 6px;\n\n        .content1 {\n            padding: 10px;\n            padding-top: 0px;\n\n            .headerDetails {\n                display: flex;\n\n                .tripDetails {\n                    width: 25%;\n                    border-right: 1.5px solid #2A3A4F;\n                    padding: 5px 0px;\n\n                    .text {\n                        font-weight: 500;\n                        font-size: 12px;\n                        line-height: 16px;\n                        color: #708299;\n                    }\n\n                    .tripID {\n                        font-weight: 500;\n                        font-size: 14px;\n                        line-height: 18px;\n                        display: flex;\n                        align-items: center;\n                        text-decoration-line: underline;\n                        color: #386DFF;\n                    }\n                }\n\n                .passengerDeatils {\n                    width: 75%;\n                    display: flex;\n                    justify-content: flex-end;\n                    text-align: right;\n                }\n            }\n\n            .description {\n                padding: 10px 0px;\n                color: white;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-weight: 500;\n                font-size: 12px;\n                line-height: 16px;\n            }\n\n            .dashedLine {\n                height: 1.5px;\n                background: repeating-linear-gradient(to right,\n                        #2A3A4F,\n                        #2A3A4F 10px,\n                        transparent 4px,\n                        transparent 20px);\n            }\n\n            .locationBox {\n                display: flex;\n\n                .location {\n                    border-bottom: 1.5px solid #2A3A4F;\n                    padding: 16px 0px;\n                    width: 45%;\n                    display: flex;\n\n                    .locationDetail {\n                        width: 85%;\n\n                        .airportCode {\n                            font-weight: 500;\n                            font-size: 20px;\n                            line-height: 24px;\n                            text-align: center;\n                            color: #FDFDFD;\n                        }\n\n                        .cityName {\n                            font-weight: 500;\n                            font-size: 12px;\n                            line-height: 16px;\n                            text-align: center;\n                            color: #708299;\n                        }\n                    }\n\n                    .lineHeader {\n                        width: 15%;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n\n                        .line {\n                            border: 1px solid #2A3A4F;\n                            width: 100%;\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                        }\n                    }\n                }\n\n                .arrow {\n                    width: 10%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n            }\n\n            .timeContainer {\n                display: flex;\n\n                .timeBox {\n                    width: 45%;\n                    display: flex;\n\n                    .scheduleDetails {\n                        padding-top: 10px;\n                        width: 85%;\n\n                        &:first-child {\n                            border-right: 1.5px solid #2A3A4F;\n                            margin-right: 8px;\n                        }\n\n                        .scheduleText {\n                            font-weight: 500;\n                            font-size: 10px;\n                            line-height: 14px;\n                            color: #8998AB;\n                        }\n\n                        .scheduleTime {\n                            display: flex;\n\n                            .time {\n                                font-weight: 500;\n                                font-size: 18px;\n                                line-height: 22px;\n                                color: #FDFDFD;\n                            }\n\n                            .timePeriod {\n                                font-weight: 500;\n                                font-size: 10px;\n                                line-height: 14px;\n                                display: flex;\n                                align-items: center;\n                                text-align: center;\n                                color: #708299;\n                                padding-left: 6px;\n                            }\n                        }\n                    }\n                }\n\n                .arrow {\n                    width: 10%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n            }\n        }\n\n        .content2 {\n            background: #121B26;\n            border-radius: 32px 32px 0px 0px;\n            padding: 10px;\n            margin-top: 10px;\n            margin-right: 6px;\n\n            .flightContainer {\n                &:last-child {\n                    .dotIcon::after {\n                        display: none;\n                    }\n                }\n\n                &.selected {\n                    .flightContent {\n                        .dotParent {\n                            .dotIcon {\n                                background: #FFFFFF;\n                                border: 2px solid #386DFF;\n\n                                &::after {\n                                    display: none;\n                                }\n                            }\n                        }\n\n                        .flightList {\n                            border: 2px solid #386DFF;\n                        }\n                    }\n                }\n\n                &.cancelled {\n                    .flightContent {\n                        .flightList {\n                            border: 2px solid #D80909;\n                        }\n                    }\n                }\n\n                .flightContent {\n                    padding: 10px;\n                    display: flex;\n\n                    .dotParent {\n                        display: flex;\n                        align-items: center;\n\n                        .dotIcon {\n                            background: #4B5F7A;\n                            border: 2px solid #384D69;\n                            width: 13px;\n                            height: 13px;\n                            border-radius: 50%;\n                            position: relative;\n\n                            &::after {\n                                content: \"\";\n                                position: absolute;\n                                top: 12px;\n                                left: 50%;\n                                transform: translateX(-50%);\n                                width: 1px;\n                                height: 117px;\n                                background-color: #2A3A4F;\n                            }\n                        }\n\n                        .mixedLine {\n                            height: 117px;\n                            position: relative;\n                            right: 7px;\n                            top: 50px;\n\n                            .mixedLineSolid {\n                                border: 1px solid #2A3A4F;\n                                height: 50%;\n                            }\n\n                            .mixedLineDashed {\n                                height: 50%;\n                                background: repeating-linear-gradient(to bottom, #2A3A4F, #2A3A4F 5px, transparent 4px, transparent 10px);\n                            }\n                        }\n                    }\n\n                    .flightList {\n                        border: 1.5px solid #4B5F7A;\n                        border-radius: 6px;\n                        width: 337px;\n                        margin: 0px 8px;\n\n                        .flightHeader {\n                            background: #1C2633;\n                            border-radius: 6px;\n                            display: flex;\n                            align-items: center;\n                            height: 30px;\n\n                            .headerLeft {\n                                width: 50%;\n                                text-align: left;\n                                color: #FDFDFD;\n                                padding: 0px 8px;\n\n                                .airlineId {\n                                    font-weight: 700;\n                                    font-size: 12px;\n                                    line-height: 16px;\n                                }\n\n                                .airlineTime {\n                                    font-weight: 500;\n                                    font-size: 10px;\n                                    line-height: 14px;\n                                    text-align: right;\n                                    padding-left: 8px;\n                                }\n                            }\n\n                            .headerRight {\n                                margin: 2px 8px;\n                                display: flex;\n                                justify-content: center;\n                                align-items: center;\n                                width: 50%;\n                                height: 20px;\n                                border-radius: 12px;\n                                font-weight: 700;\n                                font-size: 10px;\n                                line-height: 12px;\n                                text-transform: uppercase;\n\n                                &.success {\n                                    color: #55FC7F;\n                                    border: 1px solid #84FFA3;\n                                }\n\n                                &.fail {\n                                    background-color: #D80909;\n                                    border: 1px solid #D80909;\n                                    color: #FDFDFD;\n                                }\n                            }\n                        }\n\n                        .flightLocation {\n                            display: flex;\n                            padding: 8px 0px;\n\n                            .location {\n                                width: 33%;\n\n                                .airportCode {\n                                    font-weight: 500;\n                                    font-size: 12px;\n                                    line-height: 16px;\n                                    color: #A9BBC7;\n                                }\n\n                                .airportTime {\n                                    font-weight: 700;\n                                    font-size: 12px;\n                                    line-height: 16px;\n                                    color: #FDFDFD;\n                                }\n                            }\n\n                            .arrow {\n                                width: 33%;\n                                display: flex;\n                                align-items: center;\n                                justify-content: center;\n\n                                .arrowLine {\n                                    width: 26px;\n                                    height: 1px;\n                                    border: 1px solid #4B5F7A;\n                                    margin: 0px 6px;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .connectionContainer {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n\n                    .connectText {\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                        padding: 8px 24px;\n                        width: 235px;\n                        height: 28px;\n                        border-radius: 4px;\n                        font-weight: 500;\n                        font-size: 12px;\n                        line-height: 16px;\n                        text-align: center;\n\n                        &.normal {\n                            background: #1C2633;\n                            color: #A9BBC7;\n\n                            &.location {\n                                border: 2px solid #386DFF;\n                            }\n                        }\n\n                        &.success {\n                            background: #FFB8B8;\n                            color: #384D69;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.warning-icon {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n}\n\n.loading-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n}\n\n.loading-spinner {\n    width: 48px;\n    height: 48px;\n    border: 4px solid #2A3A4F;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n\n    &.airport {\n        border-top-color: #465569;\n    }\n\n    &.with-issue {\n        border-top-color: #FB4B4B;\n    }\n\n    &.no-issue {\n        border-top-color: #09AF91;\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.no-trip-details {\n    opacity: 0.8;\n    padding: 20px 0;\n    text-align: center;\n}\n\n.trip-details-header {\n    display: flex;\n\n    .trip-info {\n        width: 25%;\n        border-right: 1.5px solid #2A3A4F;\n        padding: 5px 0;\n    }\n\n    // .trip-id-link {\n    //     font-weight: 500;\n    //     font-size: 14px;\n    //     line-height: 18px;\n    //     display: flex;\n    //     align-items: center;\n    //     text-decoration: underline;\n    //     color: #386DFF;\n    //     cursor: pointer;\n    //     letter-spacing: 0;\n    // }\n\n    // .trip-id-text {\n    //     font-weight: 500;\n    //     font-size: 14px;\n    //     line-height: 18px;\n    //     display: flex;\n    //     align-items: center;\n    //     color: white;\n    // }\n\n    .passenger-info {\n        width: 75%;\n        display: flex;\n        justify-content: flex-end;\n        text-align: right;\n\n        .passengerBox {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n        }\n    }\n}\n\n// .leg-description {\n//     padding: 10px 0;\n//     color: white;\n//     display: flex;\n//     align-items: center;\n//     justify-content: center;\n//     font-size: 12px;\n//     gap: 4px;\n\n//     &__item--regular {\n//         font-weight: 400;\n//     }\n\n//     &__item--bold {\n//         font-weight: 600;\n//     }\n// }\n\n.dashed-divider {\n    height: 1.5px;\n    background: repeating-linear-gradient(to right, #2A3A4F, #2A3A4F 10px, transparent 4px, transparent 20px);\n}\n\n.current-flight-location {\n    display: flex;\n\n    .location-column {\n        border-bottom: 1.5px solid #2A3A4F;\n        padding: 16px 0 7px 0;\n        width: 45%;\n        display: flex;\n\n        .location-details {\n            width: 85%;\n        }\n\n        .location-airport-code {\n            font-weight: 500;\n            font-size: 20px;\n            line-height: 24px;\n            text-align: center;\n            color: #FDFDFD;\n        }\n\n        .location-city {\n            text-align: center;\n        }\n\n        .location-divider-container {\n            width: 15%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .location-divider {\n            border: 1px solid #2A3A4F;\n            width: 100%;\n        }\n    }\n\n    .flight-direction-arrow {\n        width: 10%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.current-flight-time {\n    display: flex;\n\n    .time-column {\n        width: 45%;\n        display: flex;\n    }\n\n    .time-group {\n        padding-top: 10px;\n        width: 85%;\n\n        &.scheduled {\n            border-right: 1.5px solid #2A3A4F;\n            margin-right: 8px;\n        }\n    }\n\n    .time-label {\n        font-weight: 500;\n        font-size: 10px;\n        line-height: 14px;\n        color: #8998AB;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n    }\n\n    .time-value-container {\n        display: flex;\n    }\n\n    .time-value {\n        font-weight: 500;\n        font-size: 15px;\n        line-height: 22px;\n        color: #FDFDFD;\n\n        &.delayed {\n            color: #FF4C4C;\n        }\n    }\n\n    .time-period {\n        font-weight: 500;\n        font-size: 11px;\n        line-height: 22px;\n        color: #FDFDFD;\n        margin-left: 2px;\n\n        &.delayed {\n            color: #FF4C4C;\n        }\n    }\n}\n\n.delayed-indicator {\n    position: relative;\n    display: inline-block;\n    margin-left: 4px;\n\n    .delay-triangle {\n        width: 0;\n        height: 0;\n        border-left: 7px solid transparent;\n        border-right: 7px solid transparent;\n        border-bottom: 10px solid #FF4C4C;\n        display: inline-block;\n    }\n\n    .delay-triangle-icon {\n        position: absolute;\n        top: 2px;\n        left: 50%;\n        transform: translateX(-50%);\n        color: black;\n        font-size: 7px;\n        font-weight: bold;\n        line-height: 1;\n        pointer-events: none;\n    }\n}\n\n.flight-card-list {\n    background: #121B26;\n    border-radius: 32px 32px 0px 0px;\n    padding: 10px;\n    margin-top: 10px;\n    margin-right: 6px;\n    position: relative;\n}\n\n.flight-card-wrapper {\n    padding: 10px;\n}\n\n.flight-card {\n    display: flex;\n\n    &__timeline {\n        display: flex;\n        align-items: center;\n    }\n\n    &__dot {\n        background: white;\n        width: 13px;\n        height: 13px;\n        border-radius: 50%;\n\n        &--completed {\n            border: 3px solid #6B7280;\n            opacity: 0.5;\n        }\n\n        &--current {\n            border: 3px solid #386DFF;\n        }\n\n        &--future {\n            border: 3px solid #9CA3AF;\n        }\n    }\n\n    &__main {\n        border-radius: 6px;\n        width: 337px;\n        margin: 0 8px;\n\n        &--completed {\n            border: 1.5px solid #6B7280;\n            opacity: 0.5;\n        }\n\n        &--current {\n            border: 1.5px solid #386DFF;\n        }\n\n        &--future-with-issue {\n            border: 1.5px solid #FF4C4C;\n        }\n\n        &--future-no-issue {\n            border: 1.5px solid #4B5F7A;\n        }\n    }\n\n    &__header {\n        background: #1C2633;\n        border-radius: 6px;\n        display: flex;\n        align-items: center;\n        height: 30px;\n    }\n\n    &__flight-info {\n        width: 50%;\n        text-align: left;\n        color: #FDFDFD;\n        padding: 0 8px;\n    }\n\n    &__flight-number {\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 16px;\n    }\n\n    &__flight-date {\n        font-weight: 350;\n        font-size: 9px;\n        line-height: 14px;\n        text-align: right;\n        padding-left: 8px;\n    }\n\n    &__status {\n        margin: 2px 8px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 50%;\n        height: 20px;\n        border-radius: 12px;\n        font-weight: 700;\n        line-height: 12px;\n        text-transform: uppercase;\n\n        &--with-issue {\n            color: #FFFFFF;\n            border: 1px solid #FF4C4C;\n            background-color: #FF4C4C;\n        }\n\n        &--no-issue {\n            color: #55FC7F;\n            border: 1px solid #84FFA3;\n            background-color: transparent;\n        }\n    }\n\n    &__details {\n        display: flex;\n        padding: 8px 0;\n    }\n\n    &__airport-info {\n        width: 33%;\n\n        &--departure {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n            text-align: right;\n        }\n    }\n\n    &__airport-code {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        color: #A9BBC7;\n    }\n\n    &__time {\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 16px;\n        color: #FDFDFD;\n    }\n\n    &__separator {\n        width: 33%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &__separator-line {\n        width: 26px;\n        height: 1px;\n        border: 1px solid #4B5F7A;\n        margin: 0 6px;\n    }\n}\n\n.connection-info-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.connection-info {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 24px;\n    width: 235px;\n    height: 28px;\n    border-radius: 4px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n\n    &--with-issue {\n        background: #FFB3B3;\n        color: #FFFFFF;\n    }\n\n    &--no-issue {\n        background: #1C2633;\n        color: #A9BBC7;\n    }\n\n    &--passenger-waiting {\n        border: 2px solid #4A90E2;\n    }\n}\n\n.textIcon {\n    position: relative;\n    left: 5px;\n    top: 1px;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.textAlignLeft {\n    text-align: left;\n}\n\n.flightContainer.selected~.flightContainer .dotIcon {\n    background: #FFFFFF !important;\n    border: 2px solid #8998AB !important;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.passenger-selected {\n    background-color: #2A3A4F !important;\n    border: 1px solid #1C2633;\n    border-radius: 8px;\n    width: fit-content;\n}\n\n.scrollContent::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n}\n\n.scrollContent::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.scrollContent::-webkit-scrollbar-thumb {\n    background: #4B5F7A;\n    border-radius: 4px;\n}\n\n.scrollContent::-webkit-scrollbar-thumb:hover {\n    background: #3a4b60;\n}\n\n.scrollContent::-webkit-scrollbar-corner {\n    background: transparent;\n    display: none;\n}\n\n/* Apply same scrollbar styles to locationContent for airport popups */\n.locationContent::-webkit-scrollbar,\n.locationContent.scrollContent::-webkit-scrollbar {\n    width: 3px !important;\n    height: 3px !important;\n}\n\n.locationContent::-webkit-scrollbar-track,\n.locationContent.scrollContent::-webkit-scrollbar-track {\n    background: transparent !important;\n}\n\n.locationContent::-webkit-scrollbar-thumb,\n.locationContent.scrollContent::-webkit-scrollbar-thumb {\n    background: #4B5F7A !important;\n    border-radius: 4px !important;\n}\n\n.locationContent::-webkit-scrollbar-thumb:hover,\n.locationContent.scrollContent::-webkit-scrollbar-thumb:hover {\n    background: #3a4b60 !important;\n}\n\n.locationContent::-webkit-scrollbar-corner,\n.locationContent.scrollContent::-webkit-scrollbar-corner {\n    background: transparent !important;\n    display: none !important;\n}\n\n.passenger-card {\n    padding-block: 4px;\n    min-width: 190px;\n}\n\n.passenger-card:first-child {\n    margin-top: 0px !important;\n}\n\n.multi-passenger-wrapper {\n    display: flex;\n    align-items: center;\n}\n\n.multi-passenger-wrapper>* {\n    flex-shrink: 0;\n}\n\n// ===== Semantic Component Classes for FlightPopup =====\n\n// Loading & No data states\n.loading-state {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n}\n\n.no-data-state {\n    opacity: 0.8;\n    padding: 20px 0;\n    text-align: center;\n}\n\n// Trip detail specific classes\n.trip-detail-header {\n    display: flex;\n}\n\n.trip-info-column {\n    width: 25%;\n    border-right: 1.5px solid #2A3A4F;\n    padding: 5px 0;\n}\n\n.passenger-info-column {\n    width: 75%;\n    display: flex;\n    justify-content: flex-end;\n    text-align: right;\n\n    .passengerBox {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n    }\n}\n\n// Time display components\n.time-row {\n    display: flex;\n\n}\n\n.time-column {\n    width: 45%;\n    display: flex;\n}\n\n.time-group {\n    padding-top: 10px;\n    width: 85%;\n\n    &.with-border {\n        border-right: 1.5px solid #2A3A4F;\n        margin-right: 8px;\n    }\n}\n\n.time-label {\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 14px;\n    color: #8998AB;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.time-value-display {\n    display: flex;\n    align-items: center;\n\n    .time {\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 22px;\n        color: #FDFDFD;\n\n        &.delayed {\n            color: #FF6B6B;\n        }\n    }\n\n    .period {\n        font-weight: 500;\n        font-size: 10px;\n        line-height: 22px;\n        color: #708299;\n        margin-left: 4px;\n\n        &.delayed {\n            color: #FF6B6B;\n        }\n    }\n}\n\n// Location display components\n.location-row {\n    display: flex;\n}\n\n.location-column {\n    border-bottom: 1.5px solid var(--bg-divider);\n    padding: 16px 0;\n    width: 45%;\n    display: flex;\n\n    .location-info {\n        width: 85%;\n    }\n\n    .location-code {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 24px;\n        text-align: center;\n        color: #FDFDFD;\n    }\n\n    .passengerLabel {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        color: #A9BBC7;\n    }\n\n    .divider-container {\n        width: 15%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .divider {\n            border: 1px solid #2A3A4F;\n            width: 100%;\n        }\n    }\n}\n\n.arrow-column {\n    width: 10%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #4B5F7A\n}\n\n// Leg description\n.leg-description {\n    padding: 10px 0;\n    color: #FDFDFD;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    gap: 4px;\n    font-style: normal;\n    font-family: Montserrat;\n\n    .leg-description-label {\n        font-weight: 400;\n    }\n\n    .leg-description-number {\n        font-weight: 700;\n    }\n\n    .leg-description-value {\n        font-weight: 700;\n    }\n}\n\n// Dashed divider\n.dashed-divider {\n    height: 1.5px;\n    background: repeating-linear-gradient(to right, #2A3A4F, #2A3A4F 10px, transparent 4px, transparent 20px);\n}\n\n// Flight Cards Container\n.flight-cards-container {\n    background: var(--bg-secondary);\n    border-radius: var(--radius-2xl) var(--radius-2xl) 0 0;\n    padding: var(--spacing-md);\n    margin-top: var(--spacing-md);\n    margin-right: 6px;\n    position: relative;\n}\n\n// Flight Card\n.flight-card {\n    padding: var(--spacing-md);\n\n    &__header {\n        display: flex;\n        align-items: center;\n    }\n\n    &__circle {\n        background: white;\n        width: var(--flight-card-circle-size);\n        height: var(--flight-card-circle-size);\n        border-radius: 50%;\n\n        &--completed {\n            border: 3px solid var(--border-disabled);\n            opacity: 0.5;\n        }\n\n        &--current {\n            border: 3px solid var(--color-primary-blue);\n            opacity: 1;\n        }\n\n        &--future {\n            border: 3px solid var(--border-future);\n            opacity: 1;\n        }\n    }\n\n    &__content {\n        border-radius: var(--radius-md);\n        width: var(--flight-card-width);\n        margin: 0 var(--spacing-sm);\n\n        &--completed {\n            border: 1.5px solid var(--border-disabled);\n            opacity: 0.5;\n        }\n\n        &--current {\n            border: 1.5px solid var(--color-primary-blue);\n            opacity: 1;\n        }\n\n        &--future {\n            border: 1.5px solid var(--border-primary);\n            opacity: 1;\n        }\n    }\n\n    &__info-bar {\n        background: var(--bg-primary);\n        border-radius: var(--radius-md);\n        display: flex;\n        align-items: center;\n        height: 30px;\n    }\n\n    &__flight-number {\n        width: 50%;\n        text-align: left;\n        color: var(--text-primary);\n        padding: 0 var(--spacing-sm);\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 16px;\n    }\n\n    &__flight-date {\n        font-weight: 350;\n        font-size: 9px;\n        line-height: 14px;\n        text-align: right;\n        padding-left: var(--spacing-sm);\n    }\n\n    &__status-badge {\n        margin: 2px var(--spacing-sm);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 50%;\n        height: 20px;\n        border-radius: var(--radius-xl);\n        font-weight: 700;\n        line-height: 12px;\n        text-transform: uppercase;\n    }\n\n    &__route {\n        display: flex;\n        padding: var(--spacing-sm) 0;\n    }\n\n    &__airport {\n        width: 33%;\n\n        &--departure {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n            text-align: right;\n        }\n\n        &--arrival {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            text-align: left;\n        }\n    }\n\n    &__airport-code {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        color: var(--text-tertiary);\n    }\n\n    &__flight-time {\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 16px;\n        color: var(--text-primary);\n    }\n\n    &__route-divider {\n        width: 33%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .line {\n            width: 26px;\n            height: 1px;\n            border: 1px solid var(--border-primary);\n            margin: 0 6px;\n        }\n    }\n}\n\n// Connection Indicator\n.connection-indicator {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &__badge {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: var(--spacing-sm) 24px;\n        width: var(--connection-indicator-width);\n        height: var(--connection-indicator-height);\n        border-radius: var(--radius-sm);\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        text-align: center;\n\n        &--normal {\n            background: var(--bg-primary);\n            color: var(--text-tertiary);\n            border: none;\n        }\n\n        &--issue {\n            background: var(--status-red-bg);\n            color: var(--text-primary);\n            border: none;\n            font-weight: 700;\n        }\n\n        &--waiting {\n            background: var(--bg-primary);\n            color: var(--text-tertiary);\n            border: 2px solid var(--color-primary-blue);\n            font-weight: 700;\n        }\n    }\n}\n\n// Connection Lines\n.connection-line {\n    position: absolute;\n    width: 1px;\n    pointer-events: none;\n    z-index: 1;\n\n    &--solid {\n        background: var(--border-primary);\n    }\n\n    &--dotted {\n        background: transparent;\n        background-image: repeating-linear-gradient(to bottom,\n                var(--border-primary) 0px,\n                var(--border-primary) 8px,\n                transparent 8px,\n                transparent 10px);\n    }\n}\n\n// Loading State\n.loading-state {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    min-height: 200px;\n}\n\n.loading-spinner {\n    width: 48px;\n    height: 48px;\n    border: 4px solid var(--bg-divider);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n\n    &--success {\n        border-top-color: var(--color-success);\n    }\n\n    &--error {\n        border-top-color: var(--color-error-secondary);\n    }\n\n    &--airport {\n        border-top-color: #465569ff;\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n// No Data State\n.no-data-state {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    min-height: 200px;\n    color: #A9BBC7;\n}\n\n// Delay Warning Icon\n.delay-warning {\n    position: relative;\n    display: inline-block;\n\n    &__triangle {\n        width: 0;\n        height: 0;\n        border-left: 7px solid transparent;\n        border-right: 7px solid transparent;\n        border-bottom: 10px solid #FF6B6B;\n        display: inline-block;\n        border-radius: 3px;\n    }\n\n    &__exclamation {\n        position: absolute;\n        top: 2px;\n        left: 50%;\n        transform: translateX(-50%);\n        color: black;\n        font-size: 9px;\n        font-weight: bold;\n        line-height: 1;\n        pointer-events: none;\n    }\n}\n\n// Warning Icon\n.warning-icon {\n    display: inline-flex;\n    align-items: center;\n    margin-left: var(--spacing-sm);\n}\n\n// Trip Detail Header\n.trip-detail-header {\n    display: flex;\n\n    .trip-info-column {\n        width: 25%;\n        border-right: 1.5px solid var(--bg-divider);\n        padding: 5px 0;\n\n        .passengerLabel {\n            font-weight: 500;\n            font-size: 12px;\n            line-height: 16px;\n            color: #A9BBC7;\n        }\n    }\n\n    .passenger-info-column {\n        width: 75%;\n        display: flex;\n        justify-content: flex-end;\n        text-align: right;\n    }\n}\n\n// Trip ID Link\n.trip-id-link {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 18px;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: #386DFF;\n    cursor: pointer;\n}\n\n.trip-external-link-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 14px;\n    height: 14px;\n    margin-left: 6px;\n    color: #B8C3D1;\n    cursor: pointer;\n    opacity: 1;\n    transition: opacity 0.2s ease;\n\n    &:hover {\n        opacity: 0.8;\n    }\n\n    svg {\n        width: 14px;\n        height: 14px;\n    }\n}\n\n.trip-id-text {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 18px;\n    color: var(--text-primary);\n}\n\n// Custom tooltip styles for consistent appearance across the application\n[data-tooltip] {\n    position: relative;\n}\n\n[data-tooltip]:hover::after {\n    content: attr(data-tooltip);\n    position: fixed;\n    z-index: 99999;\n    background-color: #2d3748;\n    color: #ffffff;\n    padding: 6px 12px;\n    font-size: 11px;\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n    font-weight: 500;\n    white-space: nowrap;\n    pointer-events: none;\n    opacity: 1;\n    border: 1px solid #4a5568;\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    left: var(--mouse-x, 0px);\n    top: var(--mouse-y, 0px);\n    transform: translate(15px, 5px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
